import cssVariables from 'Lib/cssVariables';

const { mobileBreakpoint } = cssVariables;

const mobileDesktopBreakpointQuery: MediaQueryList | null = __CLIENT__
  ? window?.matchMedia?.(`(min-width: ${mobileBreakpoint}px)`)
  : null;

export const mobileLandscapeQuery: MediaQueryList | null =
  // / most of mobile device is 16/9
  __CLIENT__ ? window?.matchMedia?.('(min-aspect-ratio: 15/9) and (orientation: landscape)') : null;

export default mobileDesktopBreakpointQuery;
